{
  "nl": {
    "ai": {
      "activation": {
        "activate": "Activeren",
        "activated": "De AI-assistent staat aan voor {client}.",
        "agreement_required": "Vink eerst het akkoord aan.",
        "deactivated": "De AI-assistent staat uit voor {client}.",
        "not_now": "Niet nu",
        "prompt": {
          "agreement": "Ik ga namens {client} akkoord met Google Cloud als subverwerker voor deze functie.",
          "dpa_label": "Bijgewerkte verwerkersovereenkomst",
          "dpa_url": "https://ziggu.io/nl/algemene-voorwaarden-13-10-2026",
          "intro": "Laat gesprekken samenvatten en antwoorden voorstellen. Gratis te testen tot 31 december 2026.",
          "processing": "Om de assistent te gebruiken, wordt de tekst van gesprekken verwerkt via Google Cloud (Gemini) binnen de EU. Google gebruikt deze gegevens niet om modellen te trainen.",
          "retention": "Assistent-gesprekken bewaren we {count} maand. | Assistent-gesprekken bewaren we {count} maanden.",
          "settings": "Je kan de assistent altijd aan- of uitzetten in de instellingen, onder {features} > {conversations}.",
          "title": "Nieuw: AI-assistent voor je projectteam"
        },
        "settings": {
          "description": "Vat gesprekken samen en stelt antwoorden voor. Aanzetten vraagt je akkoord met Google Cloud als subverwerker.",
          "impersonation": "Alleen een eigenaar van de klant kan dit zelf aan- of uitzetten, niet in een 'login als'-sessie.",
          "owner_only": "Vraag een eigenaar om de AI-assistent te activeren.",
          "owner_only_enabled": "Alleen een eigenaar kan de AI-assistent uitzetten.",
          "title": "AI-assistent",
          "toggle": "AI-assistent in gesprekken"
        },
        "snoozed": "Je kan de AI-assistent later aanzetten in de instellingen, onder {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Alle projecten",
        "cap": {
          "action": "Start een nieuw gesprek",
          "message": "U heeft de gespreksbeperking bereikt."
        },
        "empty_state": {
          "subtitle": "Stel me alles over uw klanten",
          "title": "Hoe kan ik u helpen?"
        },
        "errors": {
          "budget_reached": "Het AI-budget van deze maand is opgebruikt. Neem contact op met Ziggu om het te verhogen.",
          "generic": "Er is iets misgegaan. Probeer het opnieuw."
        },
        "history": {
          "empty": "Nog geen vorige gesprekken",
          "title": "Vorige gesprekken"
        },
        "input": {
          "disclaimer": "Resultaten kunnen onnauwkeurig zijn. Controleer belangrijke informatie altijd.",
          "hint": "Enter om te verzenden · Shift+Enter voor nieuwe regel",
          "placeholder": "Vraag over uw klanten..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Hoe stel ik notificaties in?",
          "help_project_settings": "Waar vind ik project-instellingen?",
          "open_decisions": "Welke beslissingen staan nog open?",
          "unassigned_units": "Welke units hebben nog geen klant?"
        },
        "support_cta": {
          "action": "Neem contact op met support",
          "prompt": "Antwoord niet wat u zocht?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Alle modules",
          "assistant": "Assistent",
          "conversation_agent": "Gespreksassistent",
          "label": "Module"
        },
        "allowance": {
          "edit": "Budget aanpassen"
        },
        "allowance_boost": {
          "action": "Tijdelijk verhogen",
          "action_short": "Verhogen",
          "amount_label": "Extra bedrag",
          "existing": "Er loopt deze periode al een verhoging van {amount}. Dit bedrag komt daarbij.",
          "expires": "Komt alleen voor deze periode bovenop het budget en vervalt op {date}.",
          "expires_next_reset": "Komt alleen voor deze periode bovenop het budget en vervalt bij de volgende reset.",
          "save": "Verhoging toevoegen",
          "saved": "Verhoging van {amount} toegevoegd"
        },
        "allowance_history": {
          "empty": "Nog geen wijzigingen",
          "empty_hint": "Deze klant werkt nog met het budget dat hij kreeg.",
          "entry": "{field}: {before} → {after}",
          "package_amount": "pakketbedrag",
          "title": "Budgetgeschiedenis",
          "unknown_author": "Onbekend"
        },
        "chat_detail": {
          "employee": "Medewerker",
          "empty": "Dit gesprek heeft geen berichten",
          "feedback": {
            "down": "Slecht antwoord",
            "up": "Goed antwoord"
          },
          "text_hidden": "Niet gedeeld door de medewerker",
          "title": "Gesprek"
        },
        "chats": {
          "columns": {
            "cost": "Kost",
            "employee": "Medewerker",
            "intent": "Intentie",
            "ticket": "Ticket",
            "turns": "Beurten",
            "when": "Wanneer"
          },
          "empty": "Geen gesprekken in deze periode",
          "feedback_label": "Beoordeling",
          "feedbacks": {
            "all": "Elke beoordeling",
            "down": "Duim omlaag",
            "up": "Duim omhoog"
          },
          "intent_label": "Intentie",
          "open": "Chat openen",
          "title": "Gesprekken",
          "via": "via {name}"
        },
        "client": {
          "allowance_boost": "{amount} extra tot {date}",
          "allowance_boost_next_reset": "{amount} extra tot de volgende reset",
          "allowance_free": "{amount} gratis",
          "allowance_paid": "{amount} betaald",
          "employees_active": "{count} medewerker actief | {count} medewerkers actief",
          "over_since": "Boven budget sinds {date}",
          "title": "{name} · AI",
          "used": "{used} van {allowance} verbruikt"
        },
        "clients": {
          "allowance_split": "Gratis {free} · Betaald {paid}",
          "allowance_split_boost": "Gratis {free} · Betaald {paid} · Extra {boost}",
          "columns": {
            "actions": "Acties",
            "allowance": "Budget",
            "chats": "Gesprekken in periode",
            "client": "Klant",
            "spend": "Uitgaven in periode",
            "status": "Status",
            "used": "Verbruikt deze maand"
          },
          "empty": "Geen klant gebruikte AI in deze periode",
          "export": "Exporteren",
          "title": "Klanten"
        },
        "empty_hint": "Niets gevonden voor deze module en periode.",
        "intent_mix": {
          "empty": "Geen gesprekken in deze periode",
          "row": "{chats} gesprek · {amount} | {chats} gesprekken · {amount}",
          "title": "Verdeling per intentie"
        },
        "intents": {
          "all": "Alle intenties",
          "draft": "Antwoord opstellen",
          "none": "Geen intentie",
          "question": "Vragen",
          "summary": "Samenvatting"
        },
        "kpi": {
          "clients_active": "Actieve klanten",
          "employees_active": "Actieve medewerkers",
          "spend_month": "Uitgaven deze maand",
          "spend_month_detail": "Lopende kalendermaand",
          "spend_range": "Uitgaven in periode",
          "spend_range_detail": "{count} gesprek in deze periode | {count} gesprekken in deze periode",
          "spend_today": "Uitgaven vandaag",
          "tickets_assisted": "Ondersteunde tickets"
        },
        "load_failed": {
          "description": "Herlaad de pagina of kies een andere periode.",
          "title": "AI-gebruik kon niet geladen worden"
        },
        "range": {
          "label": "Periode"
        },
        "spend": {
          "empty": "Geen uitgaven in deze periode",
          "monthly_empty": "Geen verbruik in de laatste {months} maanden",
          "monthly_hint": "Laatste {months} maanden · los van de gekozen periode",
          "monthly_title": "Kost per maand",
          "monthly_total": "{amount} in de laatste {months} maanden · los van de gekozen periode",
          "title": "Uitgaven per dag",
          "total": "{amount} in periode",
          "view": {
            "label": "Uitgaven tonen",
            "per_day": "Per dag",
            "running_total": "Cumulatief"
          }
        },
        "status": {
          "over": "Boven budget",
          "over_days": "Over · 1 dag | Over · {count} dagen"
        },
        "title": "AI-verbruik"
      },
      "settings": {
        "budget": {
          "amount_error": "Vul een bedrag in zoals 2 of 2.50",
          "boost_label": "Tijdelijke verhoging",
          "boost_label_until": "Tijdelijke verhoging tot {date}",
          "description": "Maximale kost per maand voor AI-gebruik (test-fase). Wordt herberekend op basis van token-verbruik van alle gesprekken deze maand.",
          "free_label": "Gratis budget",
          "override_help": "Laat leeg om het pakketbedrag te gebruiken ({amount}).",
          "override_label": "Afwijkend gratis budget",
          "paid_label": "Betaald budget",
          "save": "Opslaan",
          "title": "Maandelijks budget",
          "total_label": "Totaal budget",
          "usage_label": "Verbruikt deze maand",
          "usage_of": "Verbruikt deze maand, van {amount}",
          "use_package_amount": "Pakketbedrag gebruiken"
        },
        "description": "Configuratie voor AI-functies binnen jullie organisatie.",
        "title": "AI-instellingen",
        "usage": {
          "description": "Hoeveel van het AI-tegoed van deze maand verbruikt is. Bij 100% stoppen de AI-functies tot het tegoed volgende maand opnieuw start.",
          "title": "AI-verbruik"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Aanpassen",
          "ask": "Vragen",
          "draft": "Antwoord opstellen",
          "draft_empty": "Nog geen berichten om op te antwoorden",
          "follow_up": "Vervolgvraag",
          "follow_up_stop": "Stoppen met vervolgvraag",
          "new": "Nieuwe vraag",
          "summary": "Vat gesprek samen",
          "summary_empty": "Nog geen berichten om samen te vatten",
          "use_as_reply": "Als antwoord gebruiken"
        },
        "adjusting_draft": "Aanpassing van dit concept",
        "beta": "Bèta",
        "beta_tooltip": "Gratis tot eind 2026. Daarna wordt het gebruik beperkt.",
        "budget": {
          "description": "Het AI-budget van deze maand is opgebruikt. Eerdere antwoorden blijven beschikbaar.",
          "request": "We hebben het AI-budget van deze maand opgebruikt en willen het graag verhogen.",
          "request_low": "We hebben het AI-budget van deze maand bijna opgebruikt en willen het graag verhogen.",
          "title": "AI-budget bereikt",
          "warn": "{percent}% van het AI-budget van deze maand gebruikt."
        },
        "cap": "Deze chat is lang geworden. Stel liever een nieuwe vraag.",
        "collapse": "Assistent verbergen",
        "conversation": "Gesprek",
        "digest": {
          "decisions_open": "geen open beslissingen | 1 open beslissing | {count} open beslissingen",
          "installments_unpaid": "geen openstaande schijven | 1 openstaande schijf | {count} openstaande schijven",
          "issues_open": "geen open nazorgmeldingen | 1 open nazorgmelding | {count} open nazorgmeldingen",
          "nothing_open": "Niets open voor deze unit",
          "overdue": "{count} te laat",
          "title": "In één oogopslag"
        },
        "earlier_answers": "Eerdere antwoorden",
        "empty": "Vraag iets over dit gesprek, of begin met een van deze.",
        "expand": "Assistent tonen",
        "feedback": {
          "bad": "Slecht antwoord",
          "consent": "Ziggu ziet dit gesprek. Het kan namen en gegevens van klanten bevatten.",
          "consent_shared": "Dit gesprek is al gedeeld met Ziggu.",
          "good": "Goed antwoord",
          "note": "Wat had het moeten zeggen? (optioneel)",
          "send": "Versturen",
          "share": "Delen met Ziggu",
          "stop_sharing": "Stop met delen",
          "thanks": "Bedankt voor je feedback.",
          "thanks_shared": "Bedankt. Gedeeld met Ziggu.",
          "undo": "Ongedaan maken"
        },
        "following_up": "Vervolgvraag op dit antwoord",
        "footer": "Ziggu-support leest dit alleen als je het deelt of Ziggu toegang geeft. Antwoorden worden door AI gemaakt en kunnen fouten bevatten.",
        "footer_shared": "Je hebt dit gesprek gedeeld met Ziggu. Antwoorden worden door AI gemaakt en kunnen fouten bevatten.",
        "input": {
          "adjust_draft": "Pas dit concept aan, bv. korter of formeler",
          "follow_up": "Stel een vervolgvraag",
          "label": "Je vraag",
          "placeholder": "Vraag iets over dit gesprek"
        },
        "links": {
          "aftercare": "Nazorg",
          "decisions": "Beslissingen",
          "financials": "Financiën"
        },
        "placeholders": {
          "confirm": {
            "accept": "Toch versturen",
            "header": "Versturen met open plekken?",
            "message": "De assistent liet 1 plek open in dit antwoord die je nog niet hebt ingevuld. | De assistent liet {count} plekken open in dit antwoord die je nog niet hebt ingevuld."
          },
          "remaining": "nog 1 in te vullen | nog {count} in te vullen"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Vervangen",
            "header": "Je tekst vervangen?",
            "message": "Het concept vervangt de tekst in het antwoordveld."
          }
        },
        "resize": "Breedte assistent aanpassen",
        "suggestions": {
          "history": "Wat is de geschiedenis met deze klant?",
          "issues_open": "Hoeveel opleverpunten staan nog open?",
          "undecided": "Wat heeft deze klant nog niet beslist?"
        },
        "thinking": "De assistent is bezig...",
        "title": "Assistent"
      }
    }
  }
}
